import React, { Component } from "react";
import clsx from 'clsx';
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import download from "../../../../assets/img/svg/DownloadIcon.svg"
import { Tabs, Tab, AppBar, Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import del from '../../../../assets/img/svg/Del.svg'
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { getSettingsFormat } from "../../../../actions/SettingsAction";
import { TextField, InputBase, InputAdornment, IconButton, Select, MenuItem, FormControl, FormHelperText, Radio, RadioGroup, FormControlLabel } from '@material-ui/core';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import Autocomplete from "react-autocomplete"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import styles from "../../../../assets/jss/customStyle";
import $ from "jquery"
import { putMOM, getMOM_ListView, deleteMOM } from "../../../../actions/MOMAction";
import { getMOM_Materials, geteditmominfo } from "../../../../actions/MOMAction";
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";
import { FormatColorResetTwoTone } from "@material-ui/icons";
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: "none !important"
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    indicator: {
        backgroundColor: "#00838F",
    },
}));

//const EditMOM = () => {
class EditMOM extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            ProjectId: 0,
            isView: false,
            isMobile: false,
            DeleteData: [],
            cancel: false,
            Error: {
                MaterialError: false,
                DeliveryError: false,
                TotalError: false,
            },
            addData: {
                Id: 0,
                ProjectId: 0,
                Material: '',
                TotalQuantity: '',
                ReusedInMT: '',
                RecycledInMT: '',
                LandFillInMT: '',
                Delivery: '',
                Comments: '',
                ModifiedBy: ""
            },
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.ModifiedBy = localStorage.getItem("UserRoles");
        this.state.addData.Id = parseInt(localStorage.getItem("MOMEditId"))
        this.state.DeleteData.push(parseInt(localStorage.getItem("MOMEditId")))
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.geteditmominfo(this.state.addData.Id)
        dispatch(getMOM_Materials())
        dispatch(getlookupdocinfo("Matrix"))
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#MAT1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Matrix1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Matrix").addClass("d-none");
        $("#Matrix").removeClass("d-block");
        $("#MOML").removeClass("active-color");
        $("#MOMT").removeClass("fw-bolder");
    }
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }
    geteditmominfo = (id) => {
        let apiUrl = API.MOM_LISTVIEW + '/' + id
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.dispatch({ type: "MOMEDIT_DOCS", data: response.data });
                    this.state.addData.Id = response.data.Id;
                    this.state.addData.Material = response.data?.Material;
                    this.state.addData.TotalQuantity = response.data.TotalQuantity;
                    this.state.addData.ReusedInMT = response.data.ReusedInMT;
                    this.state.addData.RecycledInMT = response.data.RecycledInMT;
                    this.state.addData.LandFillInMT = response.data.LandFillInMT;
                    this.state.addData.Delivery = response.data.Delivery;
                    this.state.addData.Comments = response.data.Comments;
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }

        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.Id = parseInt(localStorage.getItem("MOMEditId"))
        this.setState({})
    };
    resize1 = () => {
        $("#MAT1 .MuiListItemText-primary").addClass("spanTopBar");

        $("#Matrix1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Matrix").removeClass("d-none");
        $("#Matrix").addClass("d-block");
        $("#MOML").addClass("active-color");
        $("#MOMT").addClass("fw-bolder");
    }
    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        })
        if (newValue === 1) {
            this.gethistorylogMOM(this.state.ProjectId)
        }
        else {
            // this.geteditmominfo(this.state.addData.Id)
        }
    };
    gethistorylogMOM = (id) => {
        let apiUrl = API.HISTORY_LOG + id + '?name=MatrixOfMaterial'
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.dispatch({ type: "HISTORY_LOG", data: response.data });
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });

    };
    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };
    handleProjectNameSearchChange = (e) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData.Material = e.target.value;
        this.setState({});

    };
    handleProjectNameSelectChange = (e) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData.Material = e;
        this.setState({});

    };
    handleStringChange = (e, node) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        if (node == "Comments") {
            if (e.target.value.length - 1 < 1000) {
                this.state.addData[node] = e.target.value;
                this.setState({});
            }
        }
        else {
            this.state.addData[node] = e.target.value;
            this.setState({});
        }

    };
    handleInputChange = (e, node) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        if (e.target.value == '') {
            this.state.addData[node] = ''
            this.setState({});
        }
        else {
            this.state.addData[node] = parseFloat(e.target.value)
            this.setState({});
        }

    };
    DeleteItem = () => {

        this.state.addData.Id = parseInt(localStorage.getItem("MOMEditId"))
        this.setState({})
        this.deleteMOM(this.state.addData.Id, this.state.addData.ModifiedBy)
    }
    deleteMOM = (id, modify) => {

        let apiUrl = API.MOM_LISTVIEW + '/' + id + "?modify=" + modify;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/matrixofmaterials")

                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };
    EditCancel = () => {
        window.$("#cancelpopup").modal("hide");
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/matrixofmaterials")
    };
    EditCancel1 = () => {
        if (this.state.value === 1) {
            this.setState({
                value: 0
            })
            this.geteditmominfo(this.state.addData.Id)
        }
        else {
            if (this.state.cancel === true) {
                window.$("#cancelpopup").modal("show");
            }
            else {
                this.props.dispatch({ type: "CANCEL", data: false });
                this.props.navigate("/matrixofmaterials")
            }
        }
    }
    ViewCancel = () => {
        this.props.navigate("/matrixofmaterials")
    };
    EditSave = () => {
        const { dispatch } = this.props;
        const { Material, Delivery, TotalQuantity, ReusedInMT, RecycledInMT, LandFillInMT } = this.state.addData;
        if (this.state.addData.Material.trim() === "") {
            this.state.Error.MaterialError = true;
            this.state.addData.Material = this.state.addData.Material.trim();
            this.setState({})
        }
        else {
            this.state.Error.MaterialError = false;
            this.state.addData.Material = this.state.addData.Material.trim();
            this.setState({})
        }
        if (this.state.addData.Delivery === "") {
            this.state.Error.DeliveryError = true;
            this.state.addData.Delivery = this.state.addData.Delivery.trim();
            this.setState({})
        }
        else {
            this.state.Error.DeliveryError = false;
            this.state.addData.Delivery = this.state.addData.Delivery.trim();
            this.setState({})
        }
        if (TotalQuantity === "" || TotalQuantity === 0) {
            this.state.Error.TotalError = true;
            this.setState({})
        }
        else {
            this.state.Error.TotalError = false;
            this.setState({})
        }
        if (this.state.addData.Material !== "" && this.state.addData.Delivery !== "" && this.state.Error.TotalError != true) {
            this.props.dispatch({ type: "CANCEL", data: false });
            if (this.state.addData.Comments != null) {
                this.state.addData.Comments = this.state.addData.Comments.trim();
                this.setState({})
            }
            if (this.state.addData.ReusedInMT == '') {
                this.state.addData.ReusedInMT = 0;
                this.setState({})
            }
            if (this.state.addData.RecycledInMT == '') {
                this.state.addData.RecycledInMT = 0;
                this.setState({})
            }
            if (this.state.addData.LandFillInMT == '') {
                this.state.addData.LandFillInMT = 0;
                this.setState({})
            }
            this.putMOM(this.state.addData, this.state.addData.Id)

        }
        else {
        }
    }
    putMOM = (data, id) => {

        let apiUrl = API.MOM_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (response?.status === 200) {
                    this.props.navigate("/matrixofmaterials")
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
    render() {
        let { classes, menuToggle, MASTERDATA_MATERIAL } = this.props;

        return (
            <>{
                this.state.isMobile ?
                    <>
                        <div className="row w-100 mt-4">
                            <div className="col-6 mt-auto">
                                <List className="pt-4 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                    <ListItem onClick={this.sidebar} >
                                        <ListItemText id={"MAT" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                        <NavigateNextIcon id="MAT" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                        <Divider className='border-bottom' />
                                    </ListItem>
                                </List>
                            </div>
                            <div className="col-6 pt-3 mt-5">
                                <h4>Edit Matrix Of Materials-Disposition</h4>
                            </div>
                        </div>


                    </>

                    :
                    <></>
            }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                {this.state.value === 1 ? <><td className="border-right" width="5%">
                                    <i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel1} ></i></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </> : <></>
                                }
                                {this.state.value == 1 ? <></> : <>
                                    <td className="border-right text-center">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel1}></i></td>
                                    <td className="border-right text-center">
                                        <span className={classes.button} onClick={this.EditSave} style={{ minWidth: '70px' }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</span>
                                    </td>
                                    <td className="border-right text-center">
                                        <span className={`${classes.button}`} onClick={this.EditCancel1} style={{ minWidth: '70px' }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</span>
                                    </td>
                                    <td className="border-right text-center">
                                        <span className={`${classes.button}`} data-target="#deletepopup" data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</span>
                                    </td>
                                </>}
                            </tr>
                        </tbody>
                    </table>
                        :
                        <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel1}></i></td>
                                    <td width="95%">
                                        {this.state.value == 1 ? <></> : <>
                                            <button className={classes.button} onClick={this.EditSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                            <button className={`${classes.button} pl-3`} onClick={this.EditCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                            <button className={`${classes.button} pl-3`} data-target="#deletepopup" data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>
                                        </>}
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "0" : "5px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 mx-2 mt-3 ml-1">Edit Matrix Of Materials-Disposition</h6>}
                        <div className="row">
                            <div >
                                <AppBar position="static" color="inherit" className={classes.root}>
                                    <Tabs
                                        value={this.state.value}
                                        onChange={this.handleChange}
                                        classes={{ indicator: classes.indicator }}
                                    >
                                        <Tab label="Details" className="px-1 ml-4" style={{ textTransform: "none", minWidth: '13px' }}{...a11yProps(0)} />
                                        <Tab label="History log" className="" style={{ textTransform: "none", minWidth: '13px' }} {...a11yProps(1)} />
                                    </Tabs>
                                </AppBar>
                                <TabPanel value={this.state.value} index={0}>
                                    <div>
                                        <div className={this.state.isMobile ? "row px-0 mt-n3" : "row px-2 mt-n3"}>
                                            <div className={`row  mx-0 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>

                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 px-0"}`}>
                                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end d-flex text-right m-0"}>Material&nbsp;:
                                                        <div className={`${classes.helperText}`}>
                                                            <div className="MuiFormHelperText-contained">*</div>
                                                        </div></label>
                                                </div>
                                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    {this.state.Error.MaterialError ?
                                                        <div className="autocomplete-wrappers">
                                                            <Autocomplete
                                                                contentEditable={true}
                                                                value={this.state.addData.Material}
                                                                inputProps={{
                                                                    placeholder: "Material",
                                                                }}
                                                                items={MASTERDATA_MATERIAL ?? []}
                                                                getItemValue={(item) => item.Name}
                                                                shouldItemRender={this.renderProjectNames.bind(this)}
                                                                renderMenu={(item) => (
                                                                    <div className="dropdowns d-block" >{item}</div>
                                                                )}

                                                                renderInput={(props) => {
                                                                    return (
                                                                        <input
                                                                            className="form-control border-radius"
                                                                            id="exampleFormControlInput1"
                                                                            {...props}
                                                                            fullWidth
                                                                            style={{ width: '100%', height: 35, fontSize: 12, color: "#000000", borderColor: 'red' }}
                                                                        />
                                                                    );
                                                                }}

                                                                renderItem={(item, isHighlighted) => (
                                                                    <div
                                                                        className={`items 
                 ${isHighlighted ? "selected-items" : ""
                                                                            }`}
                                                                    >
                                                                        {item.Name}
                                                                    </div>
                                                                )}
                                                                onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                                onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                                            />

                                                        </div>
                                                        :

                                                        <div className="autocomplete-wrappers">
                                                            <Autocomplete
                                                                contentEditable={true}
                                                                value={this.state.addData.Material}
                                                                inputProps={{
                                                                    placeholder: "Material",
                                                                }}
                                                                items={MASTERDATA_MATERIAL ?? []}
                                                                getItemValue={(item) => item.Name}
                                                                shouldItemRender={this.renderProjectNames.bind(this)}
                                                                renderMenu={(item) => (
                                                                    <div className="dropdowns d-block" >{item}</div>
                                                                )}
                                                                renderInput={(props) => {
                                                                    return (
                                                                        <input
                                                                            className="form-control border-radius"
                                                                            id="exampleFormControlInput1"
                                                                            {...props}
                                                                            style={{ height: 35, fontSize: 12, color: "#000000" }}
                                                                        />
                                                                    );
                                                                }}
                                                                renderItem={(item, isHighlighted) => (
                                                                    <div
                                                                        className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                                            }`}
                                                                    >
                                                                        {item.Name}
                                                                    </div>
                                                                )}
                                                                onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                                onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                                            />
                                                        </div>
                                                    }
                                                </div>


                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end d-flex text-right"}>Total Quantity in MT&nbsp;:
                                                        <div className={`${classes.helperText}`}>
                                                            <div className="MuiFormHelperText-contained">*</div>
                                                        </div></label>
                                                </div>
                                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    {this.state.Error.TotalError ?
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            error
                                                            placeholder="0.0"
                                                            value={this.state.addData.TotalQuantity}
                                                            onChange={(e) => { this.handleInputChange(e, "TotalQuantity") }}
                                                            type="number"
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                                maxLength: 20,
                                                                minLength: 0,
                                                                step: "0.1"
                                                            }}
                                                        />
                                                        :
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            placeholder="0.0"
                                                            value={this.state.addData.TotalQuantity}
                                                            onChange={(e) => { this.handleInputChange(e, "TotalQuantity") }}
                                                            type="number"
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                                maxLength: 20,
                                                                minLength: 0,
                                                                step: "0.1"
                                                            }}
                                                        />
                                                    }
                                                </div>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? " pt-2" : "float-end text-right"}>Reused in MT&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        type="number"
                                                        placeholder="0.0"
                                                        value={this.state.addData.ReusedInMT}
                                                        onChange={(e) => { this.handleInputChange(e, "ReusedInMT") }}
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`,
                                                            maxLength: 10,
                                                            step: "1"
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? " pt-2" : "float-end text-right"}>Recycled in MT&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        type="number"
                                                        placeholder="0.0"
                                                        value={this.state.addData.RecycledInMT}
                                                        onChange={(e) => { this.handleInputChange(e, "RecycledInMT") }} fullWidth
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`,
                                                            maxLength: 10,
                                                            step: "1"
                                                        }}
                                                    />
                                                </div>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? " pt-2" : "float-end text-right"}>Landfill in MT&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        type="number"
                                                        fullWidth
                                                        placeholder="0.0"
                                                        value={this.state.addData.LandFillInMT}
                                                        onChange={(e) => { this.handleInputChange(e, "LandFillInMT") }}
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`,
                                                            maxLength: 10,
                                                            step: "1"
                                                        }}
                                                    />
                                                </div>

                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end d-flex text-right m-0"}>Delivery&nbsp;:
                                                        <div className={`${classes.helperText}`}>
                                                            <div className="MuiFormHelperText-contained">*</div>
                                                        </div></label>
                                                </div>
                                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    {this.state.Error.DeliveryError ?
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            error
                                                            value={this.state.addData.Delivery}
                                                            onChange={(e) => { this.handleStringChange(e, "Delivery") }}
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                                maxLength: 10,
                                                                step: "1"
                                                            }}
                                                        /> : <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            value={this.state.addData.Delivery}
                                                            onChange={(e) => { this.handleStringChange(e, "Delivery") }}
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`
                                                            }}
                                                        />
                                                    }
                                                </div>
                                            </div>
                                            <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? " pt-2" : "float-end text-right"}>Comments&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12 col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                    <TextField
                                                        multiline
                                                        rows={8}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        value={this.state.addData.Comments}
                                                        onChange={(e) => { this.handleStringChange(e, "Comments") }}

                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                    <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Comments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.Comments?.length}/1000 Characters left</label>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel value={this.state.value} index={1}>
                                    <div className="row">
                                        <div className="mt-n3">
                                            <div className="col-sm-12 col-12 px-0">
                                                <div className="table-responsive mb-4" style={{ width: "100%" }}>
                                                    <table id="dataTable" className="table">
                                                        <thead>
                                                            <tr className="">
                                                                <th className="border-top border-right border-left" style={{ width: '15%', minWidth: '160px' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Timestamp</span></th>
                                                                <th className="border-top border-right" style={{ width: '10%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                                                <th className="border-top border-right" style={{ width: '15%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Action by</span></th>
                                                                <th className="border-top border-right" style={{ width: '60%', minWidth: window.innerWidth < 1000 ? '400px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Comments</span></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody style={{ fontFamily: 'Segoe UI' }}>
                                                            {this.props.historyLog && this.props.historyLog.map((i) => (
                                                                <tr>
                                                                    <td className="spandoc-td border-right border-left align-middle Nowrap">
                                                                        {moment(i.TimeStamp).format(this.props.settings.Convention ? this.props.settings.Convention + " hh:mm:ss A" : "DD/MM/YYYY hh:mm:ss A")}
                                                                    </td>
                                                                    <td className="spandoc-td border-right align-middle">{i.Action}</td>
                                                                    <td className="spandoc-td border-right align-middle">{i.ActionBy}</td>
                                                                    <td className="spandoc-td border-right align-middle">{i.Comments}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>

                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5></div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.EditCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal" onClick={() => window.$("#cancelpopup").modal("hide")} class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        MASTERDATA_MATERIAL: state.MasterDataReducer.Lookup_data || [],
        sharedmomdata: state.MOMReducer.sharedmomdata || [],
        errormompass: state.MOMReducer.errormompass || [],
        historyLog: state.commonReducer.historyLog || [],
        settings: state.commonReducer.settings || [],
    };
}

EditMOM.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditMOM))
);
